module.exports = __webpack_public_path__ + "img/switch.e106394a.png";